/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Refused_BillingInputs */



/**
* | output |
* | --- |
* | "Plans and payments aren't available in the demo." |
*
* @param {Demo_Refused_BillingInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const demo_refused_billing = /** @type {((inputs?: Demo_Refused_BillingInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Refused_BillingInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тарифы и оплата в демо недоступны.")
	return /** @type {LocalizedString} */ ("Plans and payments aren't available in the demo.")
});